import { NO_DATA_PLACEHOLDER_DASH } from '../../../constants';
import { Typography } from '../typography/typography.component';

export const EmptyValue = () => (
  <Typography component='span' variant='body2' color='text.disabled'>
    {NO_DATA_PLACEHOLDER_DASH}
  </Typography>
);
